/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { forwardRef, useEffect, useRef } from "react";
import "./FileManagerLeftSideTree.css";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import { Formatters } from "slickgrid-react";
import useFileManagerLeftSideTree from "./useFileManagerLeftSideTree";
import { HeaderWithIcon } from "@CubeComponents/html/SlickGrid1/Formatters/Formatters";
import { renderToStaticMarkup } from "react-dom/server";
import { t } from "@i18n";

interface LeftSideTreeProps {
  setSelectedFolder: Function;
  selectedFolder: any;
  fileManagerData: any;
  onFileLoad: Function;
}

const LeftSideTree = forwardRef(
  ({ setSelectedFolder, selectedFolder, fileManagerData, onFileLoad }: LeftSideTreeProps, ref) => {
    const tempRef = useRef<any>(null);
    const treeViewRef: any = ref || tempRef;

    const {
      // State
      folderTreeData,

      // Handlers
      handleOnClick,
      titleFormatter,
      collapseParentNodesWithoutChildData,
      syncSelectedFolder,
    } = useFileManagerLeftSideTree({
      setSelectedFolder,
      selectedFolder,
      fileManagerData,
      onFileLoad,
    });

    // Sync selected folder
    useEffect(() => {
      syncSelectedFolder(treeViewRef);
    }, [selectedFolder.id, folderTreeData]);

    const getTreeView = () => (
      <SlickGrid1
        ref={treeViewRef}
        gridOptions={{
          enableCheckboxSelector: false,
          enableContextMenu: false,
          forceFitColumns: true,
        }}
        titleFormatter={titleFormatter}
        selectCheckBoxOnRowClick={true}
        disableTreeCollapseOnDataChange={true}
        enableMultiSelect={false}
        surpassedDataset={folderTreeData}
        // enableFilteringOption
        enablePointerForRows
        onClick={(args: any) => handleOnClick(args, treeViewRef)}
        disableRowBorder={true}
        disableColumnBorder={true}
        disableOuterBorder={true}
        hasChildMapping="hasChild"
        parentIdMapping="parentId"
        treeGrid={true}
        setGridReady={() => collapseParentNodesWithoutChildData(treeViewRef)}
        disableChildDataFetch
        initialSortColumnId="name"
        columnDefinitions={
          [
            {
              id: "name",
              name: "Directory",
              field: "name",
              sortable: true,
              resizable: true,
              filterType: "Text",
              headerRenderer: () => renderToStaticMarkup(<HeaderWithIcon icon="directory" label={t("Directory")} />),
              formatter: Formatters.tree as any,
              minWidth: 300,
            },
          ] as any
        }
        gridHeight="100%"
      />
    );

    return <div className="w-full overflow-auto flex h-full">{getTreeView()}</div>;
  },
);

LeftSideTree.displayName = "LeftSideTree";
export default LeftSideTree;
